
import type {
  ReactElement,
  ReactNode,
} from 'react'
import {
  OverlayArrow,
  Tooltip as AriaTooltip,
  TooltipTrigger,
  type TooltipProps as AriaTooltipProps,
} from 'react-aria-components'

interface TooltipProps {
  children: ReactElement
  content: ReactNode
  isDisabled?: boolean
  placement?: AriaTooltipProps['placement']
  delay?: number
}

export function Tooltip({
  children,
  content,
  isDisabled = false,
  placement = 'top',
  delay = 400,
}: TooltipProps) {
  return (
    <TooltipTrigger
      isDisabled={isDisabled}
      delay={delay}
    >
      {children}

      <AriaTooltip
        placement={placement}
        offset={8}
        className={[
          'z-50 rounded-md',
          'bg-slate-950 px-2.5 py-1.5',
          'text-xs font-medium text-white',
          'shadow-lg outline-none',
        ].join(' ')}
      >
        <OverlayArrow>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            aria-hidden="true"
          >
            <path d="M0 0 L4 4 L8 0" />
          </svg>
        </OverlayArrow>

        {content}
      </AriaTooltip>
    </TooltipTrigger>
  )
}